import { COACHING_ASSESSMENTS, CoachingAssessmentKind, selfStarts, } from "@healthos/schemas";
/** The questionnaires a patient may start themselves, in the order they are offered. */
export const selfStartKinds = () => CoachingAssessmentKind.options.filter(selfStarts);
const answered = (q, v) => q.kind === "scale"
    ? typeof v === "number"
    : Array.isArray(v)
        ? v.length > 0
        : String(v ?? "").trim().length > 0;
/** One step of a questionnaire: the question, whether it can move on, and what the button says. */
export function assessmentStepProps(input) {
    const spec = COACHING_ASSESSMENTS[input.kind];
    const questions = spec.questions;
    const q = questions[input.step];
    const value = input.answers[q.id];
    const isAnswered = answered(q, value);
    const optional = q.kind === "text" && q.optional === true;
    const lastStep = input.step === questions.length - 1;
    return {
        spec,
        q,
        value,
        optional,
        canGo: isAnswered || optional,
        lastStep,
        count: `${input.step + 1} of ${questions.length}`,
        total: questions.length,
        progress: (input.step + 1) / questions.length,
        nextLabel: lastStep
            ? input.sending
                ? "Sending"
                : `Send to ${input.coachName}`
            : !isAnswered && optional
                ? "Skip"
                : "Next",
    };
}
/** The answers worth sending: anything left blank is dropped. */
export const finalAnswers = (answers) => Object.fromEntries(Object.entries(answers).filter(([, v]) => typeof v === "number" ? true : Array.isArray(v) ? v.length > 0 : v.trim() !== ""));
/** A multi-select answer with `id` picked or unpicked. */
export const toggleChoice = (picked, id) => picked.includes(id) ? picked.filter((p) => p !== id) : [...picked, id];
/** A waiting questionnaire's card: one the patient started opens straight away and says so. */
export function questionnaireCardProps(assessment, coachName) {
    const self = selfStarts(assessment.kind);
    return {
        spec: COACHING_ASSESSMENTS[assessment.kind],
        self,
        eyebrow: self ? "Started by you" : `From ${coachName}`,
        startLabel: self ? "Carry on" : "Start",
    };
}
//# sourceMappingURL=coaching-assessment.js.map